import { z } from 'zod';
import { createLocalStore, useLocalStore } from './local-store';

/** Alternating row bands on every table: a user setting in the account menu, kept in this browser. */
export const stripedRowsStore = createLocalStore('rgs.tables.striped', z.boolean(), false);

export const useStripedRows = () => useLocalStore(stripedRowsStore);

/** `data-striped-rows` on <html> turns the bands on for every table, dialogs included (index.css). */
export function applyStripedRows(on: boolean) {
  document.documentElement.toggleAttribute('data-striped-rows', on);
}
